<div class="cardwrap">
  <span class="title">{{ title }}</span>
  <span class="number">{{ getCount(count) }}</span>
</div>
